import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { LogService } from '../../../../services/log-service';
import GetProviderDisplayName from '../../../../components/data-driven-logo/get-provider-display-name';
import ModalPortal from '../../../../components/modal-portal';
import { useEnableDirectModeCarriers } from '../../../../feature-flags/hooks/use-enable-direct-mode-carriers';
import { DeleteLabelProvider } from '../../../../connection-components/delete-label-provider';

import style from './delete-provider-modal.module.less';
import { useSellerLabelProvider } from '../../../../hooks/use-seller-label-provider';

export const DeleteLabelProviderModal = ({ onClose, sellerLabelProviderId, onRemoveAccount }) => {
  const isDirectMode = useEnableDirectModeCarriers();
  const sellerLabelProvider = useSellerLabelProvider(sellerLabelProviderId);
  return (
    <ModalPortal containerId='delete-modal' onClose={onClose}>
      <Modal className={classnames(style['delete-modal'])}>
        <ModalHeader closeModal={onClose}>
          <FormattedMessage
            defaultMessage='Delete {providerName}'
            description='src.pages.settings.providers.delete-modal.title'
            id='Flg61o'
            values={{
              providerName: <FormattedMessage {...GetProviderDisplayName(sellerLabelProvider.labelProviderId)} />,
            }}
          />
        </ModalHeader>
        <ModalBody className={classnames(style['modal-body'], { [style['iframe-mode']]: !isDirectMode })}>
          <div className={style['disclaimer-text']}>
            <FormattedMessage
              defaultMessage='If you delete this account, it may affect automation rules, presets, checkout rates, or product defaults that run off of this carrier.'
              description='warning that deleting a carrier account may affect automation rules, presets, checkout rates, or product defaults'
              id='k0TjLE'
            />
          </div>
          <DeleteLabelProvider
            onCancel={onClose}
            onError={(error) => LogService.logError(error)}
            onRemoveAccount={onRemoveAccount}
            sellerLabelProviderId={sellerLabelProvider.sellerLabelProviderId}
          />
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};

DeleteLabelProviderModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onRemoveAccount: PropTypes.func.isRequired,
  sellerLabelProviderId: PropTypes.string.isRequired,
};

export default DeleteLabelProviderModal;
